import { createQuery } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';

export interface GetTemplateSetParams {
  templateKey: 'form-issued' | 'welcome-letter';
  id: string;
}

export type GetTemplateSetResult = {
  /**
   * The template set (email and/or SMS) for the specified template.
   */
  templateSet: MessageTemplateSet;

  /**
   * The available merge tags grouped as a tree and a map.
   */
  mergeTags: MergeTags;
};

async function getTemplateSet({ templateKey, id }: GetTemplateSetParams) {
  // make api call
  const result = await privateApi.get<GetTemplateSetResult>(
    `${import.meta.env.VITE_API_BASE_URL}/templates/${templateKey}/${id}`,
  );

  return result.data;
}

const useGetTemplateSet = createQuery<GetTemplateSetResult, GetTemplateSetParams, ErrorResponse>({
  queryKey: ['template_set'],
  fetcher: (variables) => getTemplateSet(variables),
});

export { useGetTemplateSet };
